module.exports = __webpack_public_path__ + "static/map-flower-9815cac66efb24f1f79971c479f3cc5f.png";